<template>
  <div class="checkboxes">
    <h3 v-if="title">{{ title }}</h3>
    <v-radio-group
      v-model="innerModel"
      :error="error.$dirty && error.$invalid"
      :error-messages="errorMessage"
    >
      <v-radio
        v-for="(item, index) in items"
        :key="`radio-${index}`"
        :label="item"
        :value="item"
        @change="$emit('input', $event)"
      ></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
  import generateErrorMessage from '@/utils/generateErrorMsg'
  import { isEmpty, complement } from 'ramda'

  export default {
    name: 'ERadioButtons',
    data () {
      return {
        innerModel: null
      }
    },
    props: {
      title: {
        type: String
      },
      value: {
        type: String,
        required: true
      },
      error: {
        type: Object,
        default: () => ({})
      },
      items: {
        type: Array
      }
    },
    computed: {
      errorMessage () {
        return generateErrorMessage(this.error, [])
      }
    },
    created () {
      this.innerModel = this.value
      const isNotEmpty = complement(isEmpty)
      if (this.innerModel && !isNotEmpty(this.error)) {
        this.error.$touch
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/ERadioButtons/index.vue